import { render } from "./pretty-times.vue?vue&type=template&id=4f425eea&scoped=true"
import script from "./pretty-times.vue?vue&type=script&lang=js"
export * from "./pretty-times.vue?vue&type=script&lang=js"

import "./pretty-times.vue?vue&type=style&index=0&id=4f425eea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4f425eea"

export default script